import { render, staticRenderFns } from "./insurers-modal-basic-form.vue?vue&type=template&id=6a41510d&scoped=true&"
import script from "./insurers-modal-basic-form.ts?vue&type=script&lang=ts&"
export * from "./insurers-modal-basic-form.ts?vue&type=script&lang=ts&"
import style0 from "./insurers-modal-basic-form.scss?vue&type=style&index=0&id=6a41510d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a41510d",
  null
  
)

export default component.exports